import { render, staticRenderFns } from "./ProdTaskDetailReport.vue?vue&type=template&id=28d2e3ae&scoped=true&"
import script from "./ProdTaskDetailReport.vue?vue&type=script&lang=js&"
export * from "./ProdTaskDetailReport.vue?vue&type=script&lang=js&"
import style0 from "./ProdTaskDetailReport.vue?vue&type=style&index=0&id=28d2e3ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2e3ae",
  null
  
)

export default component.exports